import * as React from 'react';
import Page from '../containers/Page'; 
import Calendar from '../containers/Calendar';

export default () => (
  <Page title="Today">
      <Calendar />
    </Page>
)